import React from 'react';

const MenuContext = React.createContext({
  selected: undefined,
});

export default MenuContext;
